import { Auth } from 'aws-amplify';
import BugTracker from './bugTracker';
import client from '../graphql/client';
import { UPDATE_FEDERATED_ID } from '../graphql/mutations';

/* ------ FEDERATED ID CHECK ------- */

export async function getUserFederatedId() {
  try {
    const credentials = await Auth.currentCredentials();
    // TODO: Look into these type mistmatches
    // @ts-ignore
    if (!credentials.data || !credentials.data.IdentityId) {
      BugTracker.notify(`Could not get a federated identity for user`);
      return;
    }
    // @ts-ignore
    return credentials.data.IdentityId;
  } catch (error) {
    BugTracker.notify(error, 'FederatedIdError');
  }
}

export async function updateFederatedId(patient: { federatedId: string; id: string }) {
  try {
    if (!patient.federatedId) {
      const federatedId = await getUserFederatedId();
      if (!federatedId) return;

      const updatedFederatedId = await client.mutate({
        mutation: UPDATE_FEDERATED_ID,
        variables: {
          federatedId
        }
      });

      if (!updatedFederatedId) {
        BugTracker.notify(`Could not update user ${patient.id} with new federated id`);
      }
    }
  } catch (error) {
    BugTracker.notify(error, 'UpdateFederatedIdError');
  }
}

// https://github.com/aws-amplify/amplify-js/issues/1067
// NOTE: This only works for email/pw accounts - It does not work correctly for user's who have signed in
// via Google Auth.
export async function doesUsernameExists(username: string) {
  const code = '000000';

  try {
    await Auth.confirmSignUp(username, code, {
      // If set to false, the API will throw an AliasExistsException error
      // if the phone number/email used already exists as an alias with a different user
      forceAliasCreation: false
    });
  } catch (error) {
    switch (error.code) {
      case 'UserNotFoundException':
        return false;
      case 'AliasExistsException':
      case 'NotAuthorizedException':
      case 'CodeMismatchException':
      case 'ExpiredCodeException':
        return true;
      default:
        return false;
    }
  }
}
